export default __webpack_public_path__ + "static/media/screenmirroring.f7f2484d.svg";